import { populateUserJwt, getAllChannels, getPaginatedChannels, createChannel, getChannelDetail, getChannelDetailByExternalId,
  addParticipant, deleteParticipant, getAdvisorChannels, getRecommendationsAndNotificationsFromAllChannels,
  deleteMultipleChannels, uploadFileAttachment, getCourseSectionChannel, createStudyGroup, deleteStudyGroup,
  getAllBadWords, getParticipantDisplayNames, getDirectChannelUsers, getDirectChannelPeerMap,
  addToDirectChannelPeerMap, updateDirectChannelPeerMap, getPlanningStreamIdsForSelectedUsers,
  getAdvisorChannelIdsForSelectedUsers } from '../api'

export const loadUserJwt = ({ state, commit }) => {
  return populateUserJwt('{}').then(data => {
    if (data !== undefined) {
      commit('LOAD_USER_JWT', data.jwt)
    }
    return data.jwt
  })
}

export const updateUnread = ({ state, commit }, {channelId, unread}) => {
  commit('LOAD_CHANNEL_UNREAD_COUNT', {channelId, unread})
  return true
}

export const loadIsChannelReady = ({ state, commit }, isChannelReady) => {
  commit('LOAD_IS_CHANNEL_READY', isChannelReady)
  return isChannelReady
}

export const updateSelectedChannel = ({ state, commit }, selectedChannel) => {
  commit('LOAD_SELECTED_CHANNEL', selectedChannel)
}

export const loadIsChannelWindowClosed = ({ state, commit }, isChannelWindowClosed) => {
  commit('LOAD_IS_CHANNEL_WINDOW_CLOSED', isChannelWindowClosed)
  return isChannelWindowClosed
}

export const loadAllChannels = ({ state, commit }) => {
  let allChannels = state.channels
  if(state.isChannelReady){
    return allChannels
  }
  return getAllChannels().then(data => {
    commit('LOAD_ALL_CHANNELS', data)
    commit('LOAD_IS_CHANNEL_READY', true)
    /*
    data.forEach((item, i) => {
      let channelId = item['externalId']
      let unread = 0
      commit('LOAD_CHANNEL_UNREAD_COUNT', {channelId, unread})
    })
    */
    return data
  })
}

export const loadPaginatedChannels = ({ state, commit }, {page, count}) => {
  return getPaginatedChannels(page, count)
}

export const loadCreateChannel = ({ state, commit }, {channel}) => {
  return createChannel(channel)
}

export const loadChannelDetailByExternalId = ({ state, commit }, externalId) => {
  return getChannelDetailByExternalId(externalId).then(data => {
    return data
  })
}

export const loadChannelDetail = ({ state, commit }, uuid) => {
  return getChannelDetail(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_CHANNEL_DETAIL', data)
    }
    return data
  })
}

export const loadAddParticipant = ({ state, commit }, {uuid, usr}) => {
  return addParticipant(uuid, usr)
}

export const loadDeleteParticipant = ({ state, commit }, {uuid, usr}) => {
  return deleteParticipant(uuid, usr)
}

export const loadAdvisorChannels = ({ state, commit }, externalIdStartWith) => {
  return getAdvisorChannels(externalIdStartWith)
}

export const loadRecommendationsAndNotificationsFromAllChannels = ({ state, commit }) => {
  return getRecommendationsAndNotificationsFromAllChannels()
}

export const loadDeleteChannels = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleChannels(itemsToDelete)
}

export const loadAttachmentUpload = ({ state, commit }, data) => {
  return uploadFileAttachment(data)
}

export const loadCourseSectionChannel = ({ state, commit }, courseSectionId) => {
  return getCourseSectionChannel(courseSectionId)
}

export const loadCreateStudyGroup = ({ state, commit }, {channelId, data}) => {
  return createStudyGroup(channelId, data)
}

export const loadDeleteStudyGroup = ({ state, commit }, {channelId, groupId}) => {
  return deleteStudyGroup(channelId, groupId)
}

export const loadAllBadWords = ({ state, commit }) => {
  let allBadWords = state.customBadWords
  if(allBadWords && allBadWords.length>0){
    return allBadWords
  }
  return getAllBadWords().then(badWords => {
    let customBadWords = []
    badWords.forEach(badWord => {
      customBadWords.push(badWord.word)
    })
    commit('LOAD_CUSTOM_BAD_WORDS', customBadWords)
    return customBadWords
  })
}

export const loadParticipantDisplayNames = ({ state, commit }, uuids) => {
  return getParticipantDisplayNames(uuids)
}

export const loadDirectChannelUsers = ({ state, commit }, courseId) => {
  return getDirectChannelUsers(courseId)
}

export const loadDirectChannelPeerMap = ({ state, commit }) => {
  return getDirectChannelPeerMap()
}

export const loadAddToDirectChannelPeerMap = ({ state, commit }, selectedUsers) => {
  return addToDirectChannelPeerMap(selectedUsers)
}

export const loadUpdateDirectChannelPeerMap = ({ state, commit }, selectedUserId) => {
  return updateDirectChannelPeerMap(selectedUserId)
}

export const loadPlanningStreamIdsForSelectedUsers = ({ state, commit }, uuids) => {
  return getPlanningStreamIdsForSelectedUsers(uuids)
}

export const loadAdvisorChannelIdsForSelectedUsers = ({ state, commit }, uuids) => {
  return getAdvisorChannelIdsForSelectedUsers(uuids)
}



// WEBPACK FOOTER //
// ./src/app/channel/vuex/actions.js